export default "__VITE_ASSET__DjplrpdX__"